// extracted by mini-css-extract-plugin
export default {"wrapper":"FileCard_wrapper__36pr6"};